var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        eager: "",
        "max-width": "450",
        "content-class": "dialog-plan-mobile-dialog",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "dialog-plan-mobile-card" },
        [
          _c(
            "v-card-title",
            { staticClass: "secondary white--text dialog-plan-mobile-title" },
            [
              _c("span", { staticClass: "font-hemi-head" }, [
                _vm._v("PIANIFICAZIONE"),
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.dismiss } },
                [
                  _c("v-icon", { staticClass: "white--text" }, [
                    _vm._v("close"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.dialog
            ? _c("asta-plan", {
                staticClass: "navy darken-2 dialog-plan-mobile-content",
                attrs: { "show-title": false, "show-settings": "" },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }